import React from 'react'

import { MapPinIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import { useConsumedSearchParamState } from '~/client/src/shared/hooks/useConsumedSearchParamState'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { SETUP_TAB_QUERY_KEY } from '../../ProjectSetUpPages'
import LocationsControls from './LocationsControls/LocationsControls'
import LocationsForms from './LocationsForms/LocationsForms'
import LocationsObjects from './LocationsObjects/LocationsObjects'
import LocationsSetupTabs, { LocationsTab } from './LocationsSetupTabs'
import LocationsProperties from './Properties/LocationsProperties'

function LocationsSetup() {
  // ?tab= deep-links into a sub-tab (from the resource picker) and is cleared once
  // consumed so a later refresh keeps the user's last selected tab.
  const [activeTab, setActiveTab] = useConsumedSearchParamState(
    SETUP_TAB_QUERY_KEY,
    Object.values(LocationsTab),
    LocationsTab.Objects,
  )

  const renderTabContent = () => {
    switch (activeTab) {
      case LocationsTab.Objects:
        return <LocationsObjects />
      case LocationsTab.Controls:
        return <LocationsControls />
      case LocationsTab.Forms:
        return <LocationsForms />
      case LocationsTab.Properties:
        return <LocationsProperties />
      default:
        return null
    }
  }

  return (
    <div className="tw:flex tw:flex-col tw:h-full">
      <div className="tw:flex tw:items-center tw:py-1.5 tw:my-2.5">
        <MapPinIcon size={20} className="tw:grow-0 tw:mr-[5px]" />
        <span className="tw:text-title-lg tw:font-semibold tw:text-foreground tw:grow-0 tw:whitespace-nowrap">
          {Localization.translator.locations}
        </span>
      </div>
      <LocationsSetupTabs activeTab={activeTab} onTabClick={setActiveTab} />
      <div className="tw:flex-1 tw:min-h-0">{renderTabContent()}</div>
    </div>
  )
}

export default observer(LocationsSetup)
